/**
 * @param {string} candidate
 * @param {string} complexity 'low'|'weak'|'medium'|'strong'
 * @param {number} minlength
 * @return {boolean}
 */
export function isStrongPassword(candidate, complexity = 'weak', minlength = 6) {
  const p = candidate?.trim() ?? '';
  if (p.length < Math.max(minlength, 6) || p.length > 63) {
    return false;
  }

  return PASSWORD_COMPLEXITY_INDEX[getPasswordComplexity(p)] >= (PASSWORD_COMPLEXITY_INDEX[complexity] ?? PASSWORD_COMPLEXITY_INDEX['strong']);
}

export const PASSWORD_COMPLEXITY_INDEX = {'low': 0, 'weak': 1, 'medium': 2, 'strong': 3, 'extra-strong': 4};

/**
 * @param {string} p
 * @return {string} 'none'|'low'|'weak'|'medium'|'strong'|'extra-strong'
 */
export function getPasswordComplexity(p) {
  if (!p || /^[0-9]*$/.test(p)) {
    return 'none';
  }

  if (p.length >= 12 && isStrong(p)) {
    return 'extra-strong';
  }

  if (isStrong(p)) {
    return 'strong';
  }

  if (isMedium(p)) {
    return 'medium';
  }

  if (isWeak(p)) {
    return 'weak';
  }

  return 'low';
}

function hasLetter(p) {
  return /[a-z]/i.test(p)
}

export function hasLower(p) {
  return /[a-z]/.test(p)
}

export function hasUpper(p) {
  return /[A-Z]/.test(p)
}

export function hasDigit(p) {
  return /[0-9]/.test(p)
}

export function hasSpecial(p) {
  return /[^0-9a-zA-Z]/.test(p)
}

function hasSpecialOrDigit(p) {
  return hasDigit(p) || hasSpecial(p);
}

function isStrong(p) {
  return hasLower(p) && hasUpper(p) && hasDigit(p) && hasSpecial(p);
}

function isMedium(p) {
  return hasLower(p) && hasUpper(p) && hasSpecialOrDigit(p);
}

function isWeak(p) {
  return hasLetter(p) && hasSpecialOrDigit(p) || hasLower(p) && hasUpper(p);
}
